export enum IPauseOrdersService {
  DELIVERY = "delivery",
  DINEIN = "dinein",
  PICKUP = "pickup",
}
